import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';

import c from '../utils/constants';

export default function useGetPublicBookingEventAvailabilityTime(
  id: string,
  date: string,
) {
  const { state } = useProvider();
  const args = state;
  return useQuery({
    queryKey: [c.BOOKING_EVENT_AVAILABILITY_TIME, id, date],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get({
        url: `api/public/calendar/moments/events/${id}/dates/${date}`,
      });

      return data?.data;
    },
    enabled: !!id && date !== 'Invalid Date',
    retry: false,
  });
}
